interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'chat', src: '//code.tidio.co/b1laduoltjaeetw5qrfa7zvmlux3e5zn.js'}
];
//code.tidio.co/dvqdebi08krk3am6pqlmfgyimrqt3ze1.js
//code.tidio.co/vxkyk0d5yiynxjk7lxjcfbqlpz6bozde.js
// http://code.tidio.co/b1laduoltjaeetw5qrfa7zvmlux3e5zn.js